<template>
  <div class="e99-fill-col">
    <div class="s-card e99-fill-item" style="margin: 5px 2px">
      <s-form-group header="Configurações da entrega"
        :collapsed="grupoColapsado" style="margin-top: 0;">
        <div class="e99-campo">
          <label>Tipo de veículo:</label>
          <select v-model="localValue.vehicleType">
            <option value="entrega_moto">moto</option>
            <option value="entrega_car">carro</option>
          </select>
        </div>
        <div class="e99-campo">
          <label>Código de coleta:</label>
          <select v-model="localValue.needPickupCode">
            <option :value="false">não</option>
            <option :value="true">sim</option>
          </select>
        </div>
        <div class="e99-campo">
          <label>Código de entrega:</label>
          <select v-model="localValue.needDropoffCode">
            <option :value="true">sim</option>
            <option :value="false">não</option>
          </select>
        </div>
        <div class="e99-campo">
          <label>Tipo do pacote:</label>
          <select v-model="localValue.packageType">
            <option value="food">alimentos</option>
            <option value="documents">documentos</option>
            <option value="electronics">eletrônicos</option>
            <option value="groceries">mantimentos</option>
            <option value="medication">medicamentos</option>
            <option value="other">outros</option>
            <option value="wear">vestuário</option>
          </select>
        </div>
        <div class="e99-campo">
          <label>Peso do pacote:</label>
          <select v-model="localValue.packageWeight">
            <option value="1kg">até 1kg</option>
            <option value="5kg">até 5kg</option>
            <option value="10kg">até 10kg</option>
            <option value="20kg">até 20kg</option>
            <option value="30kg">até 30kg</option>
          </select>
        </div>
        <div class="e99-campo">
          <label>Destinatário não localizado:</label>
          <select v-model="localValue.returnType">
            <option value="1">devolver o pacote</option>
            <option value="2">descartar o pacote</option>
          </select>
        </div>
        <div v-if="localValue.returnType == 1" class="e99-campo">
          <label>Método de devolução:</label>
          <select v-model="localValue.returnHandoverMethod">
            <option value="2">tire uma foto</option>
            <option value="3">código de verificação</option>
          </select>
        </div>
        <s-form-item v-if="!showConfig">
          <s-select2 v-if="enderecos.length" v-model="selectedEnderecoId"
            :data="enderecoOptions"
            placeholder="Selecione o endereço de entrega"
            style="width: 440px;" />
          <span v-else class="e99-endereco-vazio">
            Cliente sem endereço cadastrado.
          </span>
        </s-form-item>
      </s-form-group>
      <div v-if="!showConfig && info.orderId"
        style="margin: 12px 0; font-weight: bold; color: #333">
        ID 99Entrega: {{ info.orderId }}
      </div>
      <div v-if="!showConfig && status"
        style="margin: 12px 0; font-weight: bold; color: #333">
        Status: {{ status }}
      </div>
      <div v-if="!showConfig && cancelReasonText"
        style="margin: 8px 0; color: #b00">
        Motivo do cancelamento: {{ cancelReasonText }}
        <span v-if="cancelReasonUser"> (por {{ cancelReasonUser }})</span>
      </div>
      <div v-if="!showConfig && verifyImgs.length" style="margin: 8px 0">
        <div style="font-weight: bold; margin-bottom: 4px">Comprovações:</div>
        <div style="display: flex; flex-wrap: wrap; gap: 10px">
          <div v-for="(img, i) in verifyImgs" :key="i"
            @click="lightbox = img.url"
            style="display: flex; flex-direction: column; align-items: center; cursor: zoom-in">
            <img :src="img.url" :alt="img.label" style="width: 64px; height: 64px; object-fit: cover;
                border-radius: 6px; border: 1px solid #ccc" />
            <span
              style="font-size: 11px; color: #555; margin-top: 2px">{{ img.label }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="lightbox" @click="lightbox = ''" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0;
        background: rgba(0, 0, 0, 0.75); display: flex; align-items: center;
        justify-content: center; z-index: 99999; cursor: zoom-out">
      <img :src="lightbox" style="max-width: 92%; max-height: 92%; border-radius: 8px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5)" />
    </div>
  </div>
</template>

<script>
import MOTIVOS_CANCELAMENTO from "./motivosCancelamento";

export default {
  name: "SEntrega99Info",
  props: {
    value: { type: Object, default: () => ({}) },
    status: { type: String, default: "" },
    info: { type: Object, default: () => ({}) },
    showConfig: { type: Boolean, default: false },
    enderecos: { type: Array, default: () => [] },
  },
  computed: {
    grupoColapsado() {
      return !this.showConfig && !!(this.info && this.info.orderId);
    },
    verifyImgs() {
      const grupos = (this.info && this.info.verifyImgs) || {};
      const labels = {
        pickup: "Coleta",
        dropoff: "Entrega",
        returnHandover: "Devolução",
      };
      return Object.keys(grupos).flatMap((k) =>
        (grupos[k] || []).map((url) => ({ url, label: labels[k] || k }))
      );
    },
    cancelReasonText() {
      const r = this.info && this.info.cancelReason;
      if (!r) return "";
      const m = MOTIVOS_CANCELAMENTO.find((x) => x.codigo === r.code);
      return m ? m.texto : r.text || r.code || "";
    },
    cancelReasonUser() {
      const r = this.info && this.info.cancelReason;
      return r && r.usuarioNome ? r.usuarioNome : "";
    },
    enderecoOptions() {
      return (this.enderecos || []).map((e) => ({
        id: e.id,
        text: this.enderecoLabel(e),
      }));
    },
  },
  data() {
    return {
      localValue: {
        vehicleType: this.value.vehicleType || "entrega_moto",
        needPickupCode: this.value.needPickupCode || false,
        needDropoffCode: this.value.needDropoffCode !== false,
        returnType: this.value.returnType || "1",
        returnHandoverMethod: this.value.returnHandoverMethod || "2",
        packageType: this.value.packageType || "food",
        packageWeight: this.value.packageWeight || "1kg",
      },
      selectedEnderecoId: "",
      lightbox: "",
    };
  },
  created() {
    this.selectedEnderecoId = this.resolveEnderecoInicial();
  },
  methods: {
    resolveEnderecoInicial() {
      const lista = this.enderecos || [];
      if (!lista.length) return "";
      // Restaura a seleção previamente salva (id), se houver.
      const salvo = this.value && this.value.enderecoEntregaId;
      if (salvo != null && salvo !== "") {
        const match = lista.find((e) => String(e.id) === String(salvo));
        if (match) return match.id;
      }
      // Padrão: endereço do tipo "entrega"; senão, exige escolha (vazio).
      const entrega = lista.find((e) => e.tipo === "entrega");
      return entrega ? entrega.id : "";
    },
    enderecoLabel(e) {
      if (!e) return "";
      const texto = [e.endereco, e.numero, e.bairro, e.municipio, e.uf]
        .filter((v) => v && String(v).trim().length)
        .join(", ");
      return e.tipo ? `${e.tipo}: ${texto}` : texto;
    },
    save(action) {
      // 0 (endereço principal) é válido; só bloqueia quando nada selecionado.
      if (this.selectedEnderecoId === "" || this.selectedEnderecoId == null) {
        Notify.warning("Informe o endereço de entrega do cliente");
        return;
      }
      this.$emit("save", {
        ...this.localValue,
        enderecoEntregaId: this.selectedEnderecoId,
        action,
      });
    },
  },
};
</script>

<style scoped>
.e99-campo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 2px 10px;
}

.e99-campo select {
  width: 200px;
}

.e99-endereco-vazio {
  color: #b00;
}

.e99-fill-col {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.e99-fill-item {
  flex: 1;
  overflow: auto;
  min-height: 0;
}
</style>